import React from 'react'
import { isEmpty, trim, compose, defaultTo, prop } from 'ramda'
import { useForm, useFetch } from '../../../../hooks'
import Button from '../../../../components/inputs/Button'
import Input from '../../../../components/inputs/Input'
import Buttons from '../../../../modules/Buttons'
import { FormHeader, FormBody, Form } from '../../../../modules/Form/styled'

const FormEditCow = ({ cowid, refetchCow, onClickCancel, onClickClose, translation }) => {
    const { doFetch } = useFetch({
        url: '/rpc/change_cowno',
        method: 'POST',
        state: false
    })

    const validate = values => {
        const isEmptyNumber = compose(isEmpty, trim, defaultTo(''), prop('cowno'))
        if (isEmptyNumber(values)) {
            return {
                cowno: translation ? translation.hint : ''
            }
        }
        return {}
    }

    const updateCow = async values => {
        try {
           const res = await doFetch({
                data: {
                    ...values,
                    cowid
                }
            })
            if(res > 0) {
                refetchCow && refetchCow()
            }
            onClickClose()
        } catch (error) {
            console.log(error)
        }
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: updateCow,
        validate: validate
    })

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader>
                {translation && translation.title}
            </FormHeader>
            <FormBody>
                <Input
                    type='text'
                    maxLength={8}
                    label={translation && translation.placeholder}
                    name='cowno'
                    onChange={handleChange}
                    value={values.cowno}
                    error={errors.cowno}
                    fullWidth
                />
                <Buttons>
                    <Button
                        type='submit'
                        fullWidth
                        green
                    >
                        {translation && translation.buttons.save}
                    </Button>
                    <Button
                        type='button'
                        fullWidth
                        onClick={onClickCancel}
                    >
                        {translation && translation.buttons.cancel}
                    </Button>
                </Buttons>
            </FormBody>
        </Form>
    )
}

export default FormEditCow
